import {
    NON_ISSUE_READY_GOODS_YARN_STOCK_REPORT_REQUEST,
    NON_ISSUE_READY_GOODS_YARN_STOCK_REPORT_SUCCESS,
    NON_ISSUE_READY_GOODS_YARN_STOCK_REPORT_FAILURE,
    NON_ISSUE_READY_GOODS_YARN_STOCK_FILTER_REPORT_REQUEST,
    NON_ISSUE_READY_GOODS_YARN_STOCK_FILTER_REPORT_SUCCESS,
    NON_ISSUE_READY_GOODS_YARN_STOCK_FILTER_REPORT_FAILURE,
  } from "../types/non-issue-ready-goods-yarn-stock-report-types";
  
  const initialState = {
    nonIssueReadyGoodsYarnStockReport: {},
    nonIssueReadyGoodsYarnStockFilterReport: {},
    loading: false,
    error: null,
  };
  
  const nonIssueReadyGoodsYarnStockReportReducer = (state = initialState, action) => {
    switch (action.type) {
      case NON_ISSUE_READY_GOODS_YARN_STOCK_REPORT_REQUEST, NON_ISSUE_READY_GOODS_YARN_STOCK_FILTER_REPORT_REQUEST: {
        return {
          ...state,
          loading: true,
          error: null
        };
      }
      case NON_ISSUE_READY_GOODS_YARN_STOCK_REPORT_SUCCESS: {
        return {
          ...state,
          nonIssueReadyGoodsYarnStockReport: {...(action.payload || {})},
          loading: false,
          error: null
        };
      }
      case NON_ISSUE_READY_GOODS_YARN_STOCK_FILTER_REPORT_SUCCESS: {
        return {
          ...state,
          nonIssueReadyGoodsYarnStockFilterReport: {...(action.payload || {})},
          loading: false,
          error: null
        };
      }
      case NON_ISSUE_READY_GOODS_YARN_STOCK_REPORT_FAILURE, NON_ISSUE_READY_GOODS_YARN_STOCK_FILTER_REPORT_FAILURE: {
        return {
          ...state,
          loading: false,
          error: action.error
        };
      }
      default:
        return state;
    }
  };
  
  export default nonIssueReadyGoodsYarnStockReportReducer;
  